import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_UBICATIONS_REQUEST = "GET_UBICATIONS_REQUEST";
export const GET_UBICATIONS_SUCCESS = "GET_UBICATIONS_SUCCESS";
export const GET_UBICATIONS_ERROR = "GET_UBICATIONS_ERROR";

//* ACTIONS ------------------------------------------------
export const getUbicationsRequest = (payload = {}, callback) => ({
  type: GET_UBICATIONS_REQUEST,
  payload,
  callback,
});

export const getUbicationsSuccess = (data) => ({
  type: GET_UBICATIONS_SUCCESS,
  payload: data,
});

export const getUbicationsError = (error) => ({
  type: GET_UBICATIONS_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getUbicationsServiceRequest = async (params = {}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/ubications`, options);
};
